// extracted by mini-css-extract-plugin
export default {"item":"UgZI","box":"Qesk","label":"_2eJ2"};